import { useTheme } from "@mui/material/styles";
import Page from "ui/Page";


export default function Layout({ children }) {
	const theme = useTheme();

	const style = {
		body: { gap: theme.spacing(10), overflow: "hidden" }
	};

	return (
		<Page maxWidth="lg">
			<Page.Body sx={style.body}>
				{children}
			</Page.Body>
		</Page>
	);
};